module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/report-management/report-management.component.css
// module id = ./src/app/admin/report-management/report-management.component.css
// module chunks = main